<div class="request-types-container">
  <div class="content">
    <div class="request-type-cards">
      @if (errorMessage()) {
        <div class="error-banner" role="alert">
          <span>{{ errorMessage() }}</span>
          <button class="error-dismiss" (click)="dismissError()" aria-label="Dismiss error">×</button>
        </div>
      }
      @if (dataLoading()) {
        <app-loading-animation></app-loading-animation>
      }
      @if (dataEmpty()) {
        <div class="no-data">No requests available to start</div>
      }
      @if (dataAvailable()) {
        @for (requestType of requestTypes(); track requestType.id) {
          <div class="request-type-card-wrapper">
            <div class="request-type-card">
              <div class="request-type-card-title">{{requestType.description}}</div>
              <div>
                <button class="request-type-card-button" [attr.aria-label]="'start ' + requestType.description"
                  (click)="initiateRequest(requestType.id)">
                  START
                </button>
                <button class="request-type-card-icon" [attr.aria-label]="'start ' + requestType.description"
                  (click)="initiateRequest(requestType.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true">
                    <g>
                      <path
                        d="M82.4,48.9C82.4,48.9,82.4,48.9,82.4,48.9l-15-14.8c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l12.4,12.3H18.6   c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h59.1L65.3,63.8c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.1,1.1-0.4   l15-14.8c0,0,0,0,0,0l1.1-1.1L82.4,48.9z"/>
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
